import DataLoader from 'dataloader';

import {
  IMediaResource,
  IResourceProcessorBatchHandler,
} from '../types';

class ResourceProcessorBatch {
  private readonly resourceProcessor: DataLoader<IMediaResource, IMediaResource>;

  constructor(resourceProcessor: IResourceProcessorBatchHandler) {
    this.resourceProcessor = new DataLoader<IMediaResource, IMediaResource>((keys) => resourceProcessor(keys));
  }

  call(data: IMediaResource): Promise<IMediaResource> {
    return this.resourceProcessor.load(data);
  }
}

export default ResourceProcessorBatch;
